<div style="padding-left: 100px; padding-right: 100px">


    <!-- dashboard tiles -->
    <div class="row">

      <div class="col-md-12">

      <div class="col-md-4 col-xl-4">
        <div class="panel panel-tile text-center br-a br-grey" style=" background-color: #27ae60;">
          <div class="panel-body">
            <h1 class="fs40 mt10 mbn" style="color: white;">{{ordersTotal}}</h1>
            <h6 class="text-system" style="color: white;">TOTAL ORDERS</h6>
          </div>
          <div class="panel-footer br-t p12">
            <span class="fs11">
              <i class="fa fa-arrow-up pr5"></i> 3% INCREASE
              <b>1W AGO</b>
            </span>
          </div>
        </div>
      </div>


      <div class="col-md-4 col-xl-4">
        <div class="panel panel-tile text-center br-a br-grey" style=" background-color: #124383;  ">
          <div class="panel-body">
            <h1 class="fs40 mt10 mbn" style="color: white;">{{ordersAsiggned}}</h1>
            <h6 class="text-system" style="color: white;">ASSIGNED ORDERS</h6>
          </div>
          <div class="panel-footer br-t p12">
            <span class="fs11">
              <i class="fa fa-arrow-up pr5"></i> 3% INCREASE
              <b>1W AGO</b>
            </span>
          </div>
        </div>
      </div>


      <div class="col-md-4 col-xl-4">
        <div class="panel panel-tile text-center br-a br-grey" style="background-color: #3498db;">
          <div class="panel-body">
            <h1 class="fs40 mt10 mbn" style="color: white;">{{ ordersDelivered }}</h1>
            <h6 class="text-system" style="color: white;">DELIVERED ORDERS</h6>
          </div>
          <div class="panel-footer br-t p12">
            <span class="fs11">
              <i class="fa fa-arrow-up pr5"></i> 2.7% INCREASE
              <b>1W AGO</b>
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-xl-4">
        <div class="panel panel-tile text-center br-a br-grey" style="background-color: #e74c3c;">
          <div class="panel-body">
            <h1 class="fs40 mt10 mbn" style="color: white;">{{ordersReject}}</h1>
            <h6 class="text-system" style="color: white;">REJECT ORDERS</h6>
          </div>
          <div class="panel-footer br-t p12">
            <span class="fs11">
              <i class="fa fa-arrow-up pr5 text-success"></i> 1% INCREASE
              <b>1W AGO</b>
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-xl-4">
        <div class="panel panel-tile text-center br-a br-grey" style="background-color: #d4a91b;">
          <div class="panel-body">
            <h1 class="fs40 mt10 mbn" style="color: white;">{{ordersPending}}</h1>
            <h6 class="text-system" style="color: white;">PENDING ORDERS</h6>
          </div>
          <div class="panel-footer br-t p12">
            <span class="fs11">
              <i class="fa fa-arrow-down pr5 text-danger"></i> 6% DECREASE
              <b>1W AGO</b>
            </span>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-xl-4">
        <div class="panel panel-tile text-center br-a br-grey" style="background-color: #12448f;">
          <div class="panel-body">
            <h1 class="fs40 mt10 mbn" style="color: white;">{{ordersRequestTotal}}</h1>
            <h6 class="text-system" style="color: white;">REQUEST CLIENT APP ORDERS  </h6>

          </div>
          <div class="panel-footer br-t p12">
            <span class="fs11">
              <i class="fa fa-list pr5 text-success"></i>
              <span style="cursor: pointer;" routerLink="/requestOrder">ORDERS FROM APP</span>
            </span>
          </div>
        </div>
      </div>


    </div>




</div>




<div  *ngIf="verGra">

    <div style="display: block; margin-left: 0px">
      <canvas baseChart
        height="360"
        width="1200"
        [datasets]="barChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [colors]="barChartColors"
        [legend]="barChartLegend"
        [chartType]="barChartType">
      </canvas>
    </div>
  <!--  <button mat-button mat-raised-button color="primary" (click)="randomize()">Update</button> -->

</div>

</div>
